// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"115":"2640d0c5","320":"2ad048fe","670":"fbc50887"}[chunkId] + ".css";
};